module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAElBMVEWlGTGlGTHeuMH09fh7eo4tKkrD6/3SAAAAAXRSTlPUwVjOqwAAADdJREFUeNpjYSAZsAiSroVhVMtw0SI4mmBGtYwmmFEto1pGtQwOLe/pomU0XkYTzGggjyYY4gAAeykGDWlcNi4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/th.png
// module id = m01V
// module chunks = 0